export default __webpack_public_path__ + "static/media/Icon-Invoice.10dcdaf7.svg";